module.exports = __webpack_public_path__ + "img/img4.a676d936.png";